import { assign } from "../common/utils";

export function KWinner(rawData, rankText) {
    let R = assign({
        "id": 0,
        "uid": 0,
        // "openId": "",
        "finalScore": 0,
        "preScore": 0,
        "cId": 0,
        "isSign": 0,
        "isFinishPre": 0,
        // "isAdvance": 0,
        // "isFinishFinal": 0,
        "preRank": 0,
        // "preScoreFinishTime": "",
        "finalRank": 0,
        // "finalFinishTime": "",
        // "buyRightNum": 0,
        // "preBuyRightFinishTime": "",
        // "sellRightNum": 0,
        // "preSellRightFinishTime": "",
        "buyRank": 0,
        "sellRank": 0,
        "mtime": "",
        "ctime": ""
    }, rawData);
    R.rankText = rankText === -1 ? "倒数第一" : rankText || ''
    return R;
}
